import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { useRouter } from 'next/router'
import { Bricolage_Grotesque, Instrument_Sans, JetBrains_Mono } from 'next/font/google'
import { ToastProvider } from '@/components/generals/toast'
import { QuoteListProvider } from '@/components/generals/quote-list-provider'
import { PageTransitionProvider } from '@/components/generals/page-transition'

const sans = Instrument_Sans({
    subsets: ['latin'],
    display: 'swap'
})

const heading = Bricolage_Grotesque({
    subsets: ['latin'],
    axes: ['opsz'],
    display: 'swap'
})

const mono = JetBrains_Mono({
    subsets: ['latin'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    const router = useRouter()
    const pageKey = router.asPath.split(/[?#]/)[0]

    return (
        <div className='h-full font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <ToastProvider>
                <QuoteListProvider>
                    <PageTransitionProvider>
                        <Component key={pageKey} {...pageProps} />
                    </PageTransitionProvider>
                </QuoteListProvider>
            </ToastProvider>
        </div>
    )
}

export default App
